import React from "react";
import { Link } from "react-router-dom"
import Stepper from "../../../Components/Stepper/Stepper";
import BrandLogo from "../../../Components/BrandLogo/BrandLogo";

export default function SuperApplication(props) {
  const clickHandler = () => {
    props.onNext();
  };

  return (
    <div className="superApplication bgContainer">
      <div className="blurOverlay">
        <BrandLogo />
        <h3 className="onboardingHeading">رِدرُز</h3>
        <h6 className="onboardingMessage">
          سوپراپلیکیشن در حوزه سلامت و تناسب اندام
        </h6>
        <Stepper step={props.step} />
        <button className="mainBtn" onClick={clickHandler}>
          ادامه
        </button>
        <Link to="/loginOrRegister" className="startApp link">شروع برنامه</Link>
      </div>
    </div>
  );
}
